import React, { Suspense } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useLookupConfig } from 'src/queries'
import Card from 'src/components/Card'
import Body from './Body'
import Loading from './Loading'
import { Breadcrumb, BreadcrumbItem, Card as BSCard } from 'reactstrap'
import CreateModal from 'src/pages/lookups/Options/modals/Create'
import useToggleState from 'src/hooks/useToggleState'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const index: React.FC = (props) => {
  const id = useParams<{ id: string }>().id
  const [createToggle, , toggleCreate] = useToggleState()
  if (id === undefined) {
    return null
  }
  const config = useLookupConfig(id)
  return (
    <>
      <BSCard className='mb-2 p-2 ps-3 small text-body-secondary'>
        <Breadcrumb className='mb-0' listClassName='mb-0'>
          <BreadcrumbItem>
            <Link className='text-reset' to='/lookups'>Lookups</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>
            {config?.name ?? 'Lookup Options'}
          </BreadcrumbItem>
        </Breadcrumb>
      </BSCard>
      <Card
        title={config?.name ?? 'Lookups'}
        primaryAction={[
          {
            key: 'create',
            text: 'Create Option',
            icon: faPlus,
            onClick: toggleCreate
          }
        ]}
      >
        <Suspense fallback={<Loading />}>
          <Body />
        </Suspense>
      </Card>
      <CreateModal
        toggle={toggleCreate}
        lookupId={id}
        isOpen={createToggle}
      />
    </>
  )
}

export default index
